<template>
  <div class="search" :id="'search-' + cid" :class="{'focus': focus === true}">
    <vue-bootstrap-typeahead
      v-model="query"
			id="test"
			placeholder="Поиск..."
			class="search-input"
      :data="data"
			@hit="selected = $event"
			@focus="onFocus"
			:serializer="item => item.b24_id.toString()"
    >
		<template slot="suggestion" slot-scope="{ data, htmlText }">
			<div class="d-flex align-items-center">
				<span class="mr-4" v-html="htmlText"></span><span>{{ data.purpose }}</span>
			</div>
		</template>
		</vue-bootstrap-typeahead>
		<b-form-select v-model="searchType" :options="options" class="search-select"></b-form-select>
  </div>
</template>
<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import searchHTTP from '@/api/modules/search/search'
export default {
	components: {
		VueBootstrapTypeahead
	},
	data () {
		return {
			cid: Math.random().toString(32).slice(2),
			focus: false,
			query: '',
			data: [],
			selected: '',
			searchType: 1,
			options: [{value: 1, text: 'Платежи'}]
		}
	},
	mounted () {
		/*
		let input = document.querySelector('#search-' + this.cid + ' input')
		input.addEventListener('focus', (e) => {
			this.focus = true
		})
		input.addEventListener('blur', (e) => {
			setTimeout(() => {
				this.focus = false
			}, 100)
		})
		*/
	},
	methods: {
		search () {
			const params = {
				q: this.query,
				type: this.searchType
			}
			searchHTTP.find(params).then((response) => {
				this.data = response
			})
		},
		onFocus () {
			console.log('focus')
		}
	},
	watch: {
		query: function (val) {
			this.search()
		},
		selected: function (val) {
			this.$router.push({path: '/payments/details/' + this.selected.id + '/update'})
		}
	}
}
</script>
<style lang="scss">
.search {
	display: flex;
	position: relative;
	.search-input {
		.input-group {
			flex: none;
			display: block;
			min-width: 400px;
		}
		input {
			width: 100%;
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}
	.search-select {
		width: auto;
		background-color: #f1f1f1;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: none;
		&:focus {
			box-shadow: none !important;
			border: 1px solid #e4e7ea;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/search/navbar-search.vue